export default __webpack_public_path__ + "static/media/404.de3e17d6.png";